document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("menu-toggle");
  const icon = document.getElementById("burger-icon");

  window.addEventListener('load', function() {
    let menuOpen = false;
    const lottie = icon.getLottie();
    const middle = Math.floor(lottie.totalFrames / 2); // Half of the frames
  
    btn.addEventListener("click", () => {
      if (!menuOpen) {
        // Always start from 0
        lottie.goToAndStop(0, true);
        lottie.playSegments([0, middle], true); // Burger -> X
        menuOpen = true;
      } else {
        // Always start from the middle
        lottie.goToAndStop(middle, true);
        lottie.playSegments([middle, 0], true); // X -> Burger
        menuOpen = false;
      }
    });
  });
});